import {
  CheckBoxElement,
  DateElement,
  DividerElement,
  DropdownElement,
  Element,
  ElementType,
  ImageElement,
  RadioButtonElement,
  SignatureElement,
  SpacerElement,
  TextElement,
  TextFieldElement,
  VideoElement,
  TableElement,
  InitialsElement,
  PricingTableElement,
  BillToElement,
  ContactInfoElement,
  ShipToElement,
  QuoteAcceptanceInfoTableElement,
  FooterElement,
  HeaderElement,
  ContractInfoTableElement,
  ApprovalTableElement,
} from 'features/document/constants';

export function isElementWithFile(element: Element): element is ImageElement | FooterElement | HeaderElement {
  return (
    element.type === ElementType.Image || element.type === ElementType.Footer || element.type === ElementType.Header
  );
}

export const isCheckboxElement = (element: Element): element is CheckBoxElement => {
  return element.type === ElementType.CheckBox;
};

export const isDateElement = (element: Element): element is DateElement => {
  return element.type === ElementType.Date;
};

export const isDividerElement = (element: Element): element is DividerElement => {
  return element.type === ElementType.Divider;
};

export const isDropdownElement = (element: Element): element is DropdownElement => {
  return element.type === ElementType.Dropdown;
};

export const isImageElement = (element: Element): element is ImageElement => {
  return element.type === ElementType.Image;
};

export const isRadioButtonElement = (element: Element): element is RadioButtonElement => {
  return element.type === ElementType.RadioButton;
};
export const isSignatureElement = (element: Element): element is SignatureElement => {
  return element.type === ElementType.Signature;
};

export const isSpacerElement = (element: Element): element is SpacerElement => {
  return element.type === ElementType.Spacer;
};

export const isTextEditorElement = (element: Element): element is TextElement => {
  return element.type === ElementType.Text;
};

export const isTextFieldElement = (element: Element): element is TextFieldElement => {
  return element.type === ElementType.TextField;
};

export const isVideoElement = (element: Element): element is VideoElement => {
  return element.type === ElementType.Video;
};

export const isTableElement = (element: Element): element is TableElement => {
  return element.type === ElementType.Table;
};

export const isInitialsElement = (element: Element): element is InitialsElement => {
  return element.type === ElementType.Initials;
};

export const isPricingTableElement = (element: Element): element is PricingTableElement => {
  return element.type === ElementType.PricingTable;
};

export const isBillToElement = (element: Element): element is BillToElement => {
  return element.type === ElementType.BillTo;
};

export const isShipToElement = (element: Element): element is ShipToElement => {
  return element.type === ElementType.ShipTo;
};

export const isContactInfoElement = (element: Element): element is ContactInfoElement => {
  return element.type === ElementType.ContactInfo;
};

export const isContractInfoTableElement = (element: Element): element is ContractInfoTableElement => {
  return element.type === ElementType.ContractInfoTable;
};

export const isQuoteAcceptanceInfoTableElement = (element: Element): element is QuoteAcceptanceInfoTableElement => {
  return element.type === ElementType.QuoteAcceptanceInfoTable;
};

export const isApprovalTableElement = (element: Element): element is ApprovalTableElement => {
  return element.type === ElementType.ApprovalTable;
};
